import { render } from "./PersonalAreaBtn.vue?vue&type=template&id=5ecbce5e"
import script from "./PersonalAreaBtn.vue?vue&type=script&lang=js"
export * from "./PersonalAreaBtn.vue?vue&type=script&lang=js"

import "./PersonalAreaBtn.vue?vue&type=style&index=0&id=5ecbce5e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__